export default __webpack_public_path__ + "static/media/CNo.81-3.b431a150.jpg";